export const INQUIRY_REQUEST = "INQUIRY_REQUEST"
export const INQUIRY_SUCCESS = "INQUIRY_SUCCESS"